export enum NotificationsTypesEnum {
  AccordanceCreate = 1,
  AccordanceCanceled,
  AccordanceComment,
  AccordanceApproved,
  AccordanceToApprove,
  AccordanceReject,
  AccordanceCompleted,
  PortfolioReviewDetails,
  PortfolioReviewDate,
  CalendarDisbursement,
  CalendarActivity,
  CalendarAcquisition,
  CalendarAccordance,
  DisbursementReminder,
  AcquisitionReminder,
  ActivityReminder,
  MonitoringAccordanceReminder,
  RevisionAccordanceReminder,
  PortfolioReviewProjectRemoved,
  PortfolioReviewPublished,
  LeaveDelegationCreated,
  ContentManagerNotification,
  GCMAlert,
  NewEarlyWarningAlert,
  EarlyWarningAutoGeneratedReport,
  ProjectsDisbursement80Percent,
  AccordanceExpired
}
